<template>
  <div id="malltheme">
    <div class="br-contentpanel" :data-min="leftSideStatus">
      <div>
        <div
          class="br-pagetitle d-flex justify-content-between align-items-center"
        >
          <div class="d-flex align-items-center">
            <i class="icon ion-bag"></i>
            <div class="mg-l-20">
              <h4>{{ $t("router.主题设置") }}</h4>
            </div>
          </div>
        </div>
      </div>
      <div
        class="card mg-x-50 pd-20 mg-y-20 card-subuser"
        v-if="isSysRights('SupplierMallConfig.addConfig')"
      >
        <div class="row form-group mg-b-40">
          <label
            class="
              col-form-label col-md-1 col-sm-1
              form-control-sm
              text-right
              tx-white
            "
          >
            {{ $t("mall.pc端：") }}
          </label>
          <div class="col-md-3 col-sm-3 tx-white">
            <label
              style="display: inline-block"
              class="ckbox mg-b-0 mg-r-20 d-flex align-items-center"
            >
              <input
                type="radio"
                value="red"
                v-model="params.pc"
                @change="setConfig"
                style="width: 15px; height: 15px"
              />
              <div class="d-flex align-items-center mg-l-10">
                <div
                  class="rectangle"
                  style="background: rgba(48, 48, 48, 1)"
                ></div>
                <div
                  class="rectangle"
                  style="background: rgba(179, 30, 34, 1)"
                ></div>
                <div
                  class="rectangle"
                  style="background: rgba(246, 98, 80, 1)"
                ></div>
              </div>
            </label>
            <div class="mg-l-25 mg-t-10">
              <img src="/img/red.png" style="width: 191px; height: 114px" />
            </div>
          </div>
          <div class="col-md-3 col-sm-3 tx-white">
            <label
              style="display: inline-block"
              class="ckbox mg-b-0 mg-r-20 d-flex align-items-center"
            >
              <input
                type="radio"
                value="green"
                v-model="params.pc"
                @change="setConfig"
                style="width: 15px; height: 15px"
              />
              <div class="d-flex align-items-center mg-l-10">
                <div
                  class="rectangle"
                  style="background: rgba(19, 33, 78, 1)"
                ></div>
                <div
                  class="rectangle"
                  style="background: rgba(8, 130, 145, 1)"
                ></div>
                <div
                  class="rectangle"
                  style="background: rgba(161, 168, 176, 1)"
                ></div>
              </div>
            </label>
            <div class="mg-l-25 mg-t-10">
              <img src="/img/green.png" style="width: 191px; height: 114px" />
            </div>
          </div>
        </div>
        <div class="row form-group">
          <label
            class="
              col-form-label col-md-1 col-sm-1
              form-control-sm
              text-right
              tx-white
            "
          >
            {{ $t("mall.移动端：") }}
          </label>
          <div class="col-md-3 col-sm-3 tx-white">
            <label
              style="display: inline-block"
              class="ckbox mg-b-0 mg-r-20 d-flex align-items-center"
            >
              <input
                type="radio"
                value="red"
                v-model="params.applet"
                @change="setConfig"
                style="width: 15px; height: 15px"
              />
              <div class="d-flex align-items-center mg-l-10">
                <div
                  class="rectangle"
                  style="background: rgba(221, 221, 221, 1)"
                ></div>
                <div
                  class="rectangle"
                  style="background: rgba(250, 250, 250, 1)"
                ></div>
                <div
                  class="rectangle"
                  style="background: rgba(254, 52, 92, 1)"
                ></div>
              </div>
            </label>
            <div class="mg-l-25 mg-t-10">
              <img src="/img/red1.png" style="width: 85px; height: 143px" />
            </div>
          </div>
          <div class="col-md-3 col-sm-3 tx-white">
            <label
              style="display: inline-block"
              class="ckbox mg-b-0 mg-r-20 d-flex align-items-center"
            >
              <input
                type="radio"
                value="green"
                v-model="params.applet"
                @change="setConfig"
                style="width: 15px; height: 15px"
              />
              <div class="d-flex align-items-center mg-l-10">
                <div
                  class="rectangle"
                  style="background: rgba(19, 33, 78, 1)"
                ></div>
                <div
                  class="rectangle"
                  style="background: rgba(8, 130, 145, 1)"
                ></div>
                <div
                  class="rectangle"
                  style="background: rgba(161, 168, 176, 1)"
                ></div>
              </div>
            </label>
            <div class="mg-l-25 mg-t-10">
              <img src="/img/green1.png" style="width: 85px; height: 143px" />
            </div>
          </div>
        </div>
      </div>
      <no-rights v-else></no-rights>
    </div>
    <api-loading :show="loading"></api-loading>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 左边栏状态
      leftSideStatus: true,
      loading: false,
      params: {
        pc: "",
        applet: "",
      },
    };
  },
  created() {
    this.getConfig();
  },
  methods: {
    /**
     * 获取默认配置
     */
    getConfig() {
      this.loading = true;
      $.api_call("api.SupplierMallConfig.getConfig", {}, (r) => {
        this.loading = false;
        if (r.ErrorCode == "9999") {
          const themeJson = r.Data.Results.themeJson || {};
          this.params.pc = themeJson.pc || "red";
          this.params.applet = themeJson.applet || "red";
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    /**
     * 修改主题
     */
    setConfig() {
      this.loading = true;
      $.api_call(
        "api.SupplierMallConfig.addConfig",
        {
          themeJson: { pc: this.params.pc, applet: this.params.applet },
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            ShowTip(this.$t("mall.修改成功"), "success");
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
  },
};
</script>

<style lang='less' scoped>
.rectangle {
  width: 58px;
  height: 30px;
}
</style>